import { render, staticRenderFns } from "./SelTeamList.vue?vue&type=template&id=3fba0478&"
import script from "./SelTeamList.vue?vue&type=script&lang=js&"
export * from "./SelTeamList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports